export const transformTermsAndConditionsContentDto = dto => {
  var _dto$updates, _dto$updates2;

  return {
    title: dto.title,
    text: dto.text,
    updates: {
      title: (_dto$updates = dto.updates) === null || _dto$updates === void 0 ? void 0 : _dto$updates.title,
      text: (_dto$updates2 = dto.updates) === null || _dto$updates2 === void 0 ? void 0 : _dto$updates2.text
    },
    additionalActions: dto === null || dto === void 0 ? void 0 : dto.additional_actions
  };
};